export const subjects = [
  "Embodied AI & Robot Skills",
  "Edge AI for Smart & Safe Cities",
  "Resilience & Dual-Use Hardware",
  "AI for SMB Manufacturing",
  "AI-Native Devices & HMI",
  "Health & Aging-in-Place",
];
